import { graphql } from '@/generated/gql';

export const INTAKE_TACTICAL_SOURCING_SELECTION = graphql(/* GraphQL */ `
  query IntakeTacticalSourcingSelection($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        tacticalSourcing {
          isSkipped
        }
      }
    }
  }
`);
